module.exports = __webpack_public_path__ + "media/images/emblems/GW-VD-Villarzel-b8457f7076c378042d9d70732a663714.png";